const DEFAULT_MAX_SNAPSHOTS = 50;

export interface EditHistoryState {
    undoStack: string[];
    redoStack: string[];
    maxSnapshots: number;
}

export const createEditHistory = (maxSnapshots = DEFAULT_MAX_SNAPSHOTS): EditHistoryState => ({
    undoStack: [],
    redoStack: [],
    maxSnapshots
});

export const pushEditSnapshot = (history: EditHistoryState, snapshot: string): void => {
    if (history.undoStack[history.undoStack.length - 1] === snapshot) return;

    history.undoStack.push(snapshot);
    if (history.undoStack.length > history.maxSnapshots) {
        history.undoStack.shift();
    }
    history.redoStack = [];
};

export const undoEditSnapshot = (history: EditHistoryState, current: string): string | null => {
    const previous = history.undoStack.pop();
    if (previous === undefined) return null;

    if (history.redoStack[history.redoStack.length - 1] !== current) {
        history.redoStack.push(current);
        if (history.redoStack.length > history.maxSnapshots) {
            history.redoStack.shift();
        }
    }

    return previous;
};

export const redoEditSnapshot = (history: EditHistoryState, current: string): string | null => {
    const next = history.redoStack.pop();
    if (next === undefined) return null;

    if (history.undoStack[history.undoStack.length - 1] !== current) {
        history.undoStack.push(current);
        if (history.undoStack.length > history.maxSnapshots) {
            history.undoStack.shift();
        }
    }

    return next;
};

export const clearEditHistory = (history: EditHistoryState): void => {
    history.undoStack = [];
    history.redoStack = [];
};

export const canUndo = (history: EditHistoryState): boolean => history.undoStack.length > 0;

export const canRedo = (history: EditHistoryState): boolean => history.redoStack.length > 0;
